import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { Community, MembershipListConfig } from "../../../../models";

@Component({
  selector: "membership-list-modal",
  templateUrl: "./membership-list-modal.component.html",
  styleUrls: [
    "./membership-list-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class MembershipListModal implements OnInit {
  // list component inputs
  @Input() community: Community;
  @Input() limit: number;
  @Input() config: MembershipListConfig;

  // modal inputs
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
